(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/views/dummy.js') >= 0) return;  svs.modules.push('/modules/player-login/views/dummy.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_login=_svs.player_login||{};
_svs.player_login.templates=_svs.player_login.templates||{};
svs.player_login.templates.dummy = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div></div>\n";
},"useData":true});
Handlebars.partials['svs-player_login-dummy'] = svs.player_login.templates.dummy;
})(svs, Handlebars);

 })(window);